var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResult(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "result",
    transform: "translate(-7.5 -3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13407",
    "data-name": "Path 13407",
    d: "M21,34.5h4.364v1.143H21Z",
    transform: "translate(-8.591 -19.5)",
    fill: "#868a97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13408",
    "data-name": "Path 13408",
    d: "M15,34.5h1.091v1.143H15Z",
    transform: "translate(-4.773 -19.5)",
    fill: "#868a97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13409",
    "data-name": "Path 13409",
    d: "M21,27h4.364v1.143H21Z",
    transform: "translate(-8.591 -14.857)",
    fill: "#868a97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13410",
    "data-name": "Path 13410",
    d: "M15,27h1.091v1.143H15Z",
    transform: "translate(-4.773 -14.857)",
    fill: "#868a97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13411",
    "data-name": "Path 13411",
    d: "M21,19.5h4.364v1.143H21Z",
    transform: "translate(-8.591 -10.214)",
    fill: "#868a97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13412",
    "data-name": "Path 13412",
    d: "M15,19.5h1.091v1.143H15Z",
    transform: "translate(-4.773 -10.214)",
    fill: "#868a97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13413",
    "data-name": "Path 13413",
    d: "M18.409,4.714H16.773V4.143A1.118,1.118,0,0,0,15.682,3H11.318a1.118,1.118,0,0,0-1.091,1.143v.571H8.591A1.118,1.118,0,0,0,7.5,5.857v12A1.118,1.118,0,0,0,8.591,19h9.818A1.118,1.118,0,0,0,19.5,17.857v-12A1.118,1.118,0,0,0,18.409,4.714Zm-7.091-.571h4.364V6.429H11.318Zm7.091,13.714H8.591v-12h1.636V7.571h6.545V5.857h1.636Z",
    fill: "#868a97"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResult);
export default __webpack_public_path__ + "static/media/result.122741a0a6b8878026458cacf81a6713.svg";
export { ForwardRef as ReactComponent };